module.exports = __webpack_public_path__ + "static/media/error.96352c3e.jpg";